import styled from 'styled-components'

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const Container = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp16};
`

export const FieldContainer = styled.div`
  flex-grow: 1;
`
